export default __webpack_public_path__ + "static/media/91.f604cbbc.gif";